import { lazy } from 'react';

const Home = lazy(() => import('views/Home/container'));
const Platform = lazy(() => import('views/Platform/container'));
const Company = lazy(() => import('views/Company/container'));
const Academy = lazy(() => import('views/Academy/container'));
const Agents = lazy(() => import('views/Agents/container'));
const Specialist = lazy(() => import('views/Specialist/container'));
const Sources = lazy(() => import('views/Sources/container'));
const HowWeWork = lazy(() => import('views/HowWeWork/container'));
const Solution = lazy(() => import('views/Solution/container'));
const Industry = lazy(() => import('views/Industry/container'));
const About = lazy(() => import('views/About/container'));
const Help = lazy(() => import('views/Help/container'));
const FreeDemo = lazy(() => import('views/FreeDemo'));
const Cases = lazy(() => import('views/Cases/container'));
const Calculator = lazy(() => import('views/Calculator/container'));
const SinglePost = lazy(() => import('views/SinglePost/container'));
const Admin = lazy(() => import('views/Admin'));
const EditPost = lazy(() => import('views/EditPost'));
import ToSpecialist from './ToSpecialist';
import ToLegal from './ToLegal';
const StatusSection = lazy(() => import('views/StatusSection/container'));
const IncidentHistory = lazy(() => import('views/IncidentHistory/container'));
const PlanForm = lazy(() => import('views/PlanForm/container'));
const Advertising = lazy(() => import('views/Advertising/container'))

const Security = lazy(() => import('views/Security'));
const Legal = lazy(() => import('views/Legal'));

const routes = {
  public: [
    {
      path: '/:language/terms',
      key: 'terms',
      exact: true,
      component: ToLegal,
    },
    {
      path: '/:language/privacy',
      key: 'privacy',
      exact: true,
      component: ToLegal,
    },
    {
      path: '/:language/security',
      key: 'security',
      exact: true,
      component: Security,
    },
    {
      path: '/:language/legal/:doc',
      key: 'legal',
      exact: true,
      component: Legal,
    },
    {
      path: ['/:language/'],
      key: 'home',
      component: Home,
      exact: true,
      title: 'home',
    },
    {
      path: '/:language/platform',
      key: 'platform',
      component: Platform,
      exact: true,
      title: 'platform',
    },
    {
      path: '/:language/company',
      key: 'company',
      component: Company,
      exact: true,
      title: 'Company',
    },
    {
      path: '/:language/academy',
      key: 'academy',
      component: Academy,
      exact: true,
      title: 'Academy',
    },
    {
      path: '/:language/specialist',
      key: 'specialist',
      component: Specialist,
      exact: true,
      title: 'Specialist',
    },
    {
      path: '/:language/sources',
      key: 'sources',
      component: Sources,
      exact: true,
      title: 'Sources',
    },
    {
      path: '/:language/how-we-work',
      key: 'howWeWork',
      component: HowWeWork,
      exact: true,
      title: 'HowWeWork',
    },
    {
      path: '/:language/solutions/:slug',
      key: 'solution',
      component: Solution,
      exact: true,
      title: 'Solution',
    },
    {
      path: '/:language/industries/:slug',
      key: 'industry',
      component: Industry,
      exact: true,
      title: 'Industry',
    },
    {
      path: '/:language/about',
      key: 'about',
      component: About,
      exact: true,
      title: 'About',
    },
    {
      path: '/:language/help',
      key: 'help',
      component: Help,
      exact: true,
      title: 'Help',
    },
    {
      path: '/:language/cases',
      key: 'cases',
      component: Cases,
      exact: true,
      title: 'Cases',
    },
    {
      path: '/:language/calculator',
      key: 'calculator',
      component: Calculator,
      exact: true,
      title: 'Calculator',
    },
    {
      path: '/:language/agents',
      key: 'agents',
      component: Agents,
      exact: true,
      title: 'Agents',
    },
    {
      path: '/:language/contact',
      key: 'contact',
      component: ToSpecialist,
      exact: true,
    },
    {
      path: '/:language/post/:id',
      key: 'post',
      component: SinglePost,
      exact: true,
      title: 'post',
    },
    {
      path: '/:language/admin',
      key: 'admin',
      exact: true,
      component: Admin,
    },
    {
      path: '/:language/admin/post/:id',
      key: 'admin',
      exact: true,
      component: EditPost,
    },
    {
      path: '/:language/pricing',
      key: 'pricing',
      exact: true,
      component: ToSpecialist,
    },
    {
      path: '/:language/status',
      key: 'status',
      exact: true,
      component: StatusSection,
    },
    {
      path: '/:language/incident-history',
      key: 'history',
      exact: true,
      component: IncidentHistory,
    },
    {
      path: '/:language/form/free-demo',
      key: 'freeDemo',
      component: FreeDemo,
      exact: true,
      title: 'FreeDemo',
    },
    {
      path: '/:language/form/:plan',
      key: 'form',
      exact: true,
      component: PlanForm,
    },
    {
      path: '/:language/free-demo-cx-:version',
      // key: 'advertising',
      exact: true,
      component: Advertising,
    },
  ],
};

export default routes;
